
import { AppBar, Link, Stack, Toolbar } from "@mui/material";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { LOCALES } from '../../features/language/locales';
import { setOrderSummaryDataList, setSearchFieldList } from '../../features/ordersummary/orderSummarySlice';
import engImage from '../../resources/images/gm_fleet_logo_english.png';
import freImage from '../../resources/images/gm_fleet_logo_french.png';
import { styles } from '../../style/style';
import UserIcon from '../components/UserIcon';
import AdminDropDown from './AdminDropDown';
import FleetBreadcrumbs from './FleetBreadcrumbs';
import { HistoryProvider } from './HistoryProvider';
import LanguageSelection from "./LanguageSelection";
import { LanguageContext } from './LanguageWrapper';

const Header = () => {

    let img = "";
    const dispatch = useDispatch();
    const context = useContext(LanguageContext);
    //const user = useSelector((state) => state.user.data.payload);
    const user = useSelector((state) => state.user.data.payload);
    const userCountry = user.country;



    if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
        if (localStorage.getItem('locale') === LOCALES.ENGLISH_US) {
            img = engImage;
        } else if (localStorage.getItem('locale') === LOCALES.FRENCH_CA) {
            img = freImage;
        }
        else {
            img = engImage;
        }
    } else {
        if (context.locale === LOCALES.ENGLISH_US) {
            img = engImage;
        } else if (context.locale === LOCALES.FRENCH_CA) {
            img = freImage;
        } else {
            img = engImage;
        }
    }

    const clearSearchField = () => {
        dispatch(setSearchFieldList({
            primaryFan: '',
            chargeToBac: '',
            endUserFan: '',
            modelYear: [],
            chargeToBfc: '',
            shipToBac: ''
        }));

        dispatch(setOrderSummaryDataList());
    }

    return (

        <Box>
            <Stack direction="row" spacing={2}>
                <Toolbar>
                    <Box component="img" id="gmFleetLogo" sx={styles.boxSX} alt="Your logo." src={img}
                    />
                </Toolbar>
                <Typography  variant="h1" id="appTitle" color="blackrgba(0, 0, 0, 0.87)" sx={styles.h1ApplicationTitle}>
                    <FormattedMessage id='header.appname' defaultMessage='Vehicle Order Status' />
                </Typography>

                <Stack direction='row' spacing={2} sx={styles.headerIcons}>
                    {/* Notification Icon for header */}
                    {/* <AlertNotification /> */}
                    <UserIcon />
                </Stack>
            </Stack>


            <Box >
                <AppBar position='static' elevation={1} style={styles.appbar}>

                    <Stack direction='row' divider={<Divider orientation="vertical" flexItem />} >
                        <Link id="navBarHome" style={styles.activeTab(window.location.href.split('/').pop(), "home")} color='inherit' href="/home" underline="none" sx={styles.headerLinkSX} >
                            <FormattedMessage id='mainnavbar.home' defaultMessage='HOME' />
                        </Link>
                        
                        {/* Header portion for Dashboard */}
                        {/* <Link style={styles.activeTab(window.location.href.split('/').pop(), "dashboard")} color='inherit' href="/dashboard" underline="none" sx={styles.headerLinkSX}>
                            <FormattedMessage id='mainnavbar.dashboard' defaultMessage='DASHBOARD' />
                        </Link> */}

                        <Link onClick={clearSearchField} id="navBarOrderSummary" style={styles.activeTab(window.location.href.split('/').pop(), "ordersummary")} color='inherit' href="/ordersummary" underline="none" sx={styles.headerLinkSX}>
                            <FormattedMessage id='mainnavbar.ordersummary' defaultMessage='ORDER SUMMARY' />
                        </Link>
                        <Link id="navBarAdvancedSearch"style={styles.activeTab(window.location.href.split('/').pop(), "advancedsearch")} color='inherit' href="/advancedsearch" underline="none" sx={styles.headerLinkSX}>
                            <FormattedMessage id='mainnavbar.advancedsearch' defaultMessage='ADVANCED SEARCH' />
                        </Link>
                        {user.partnerType === "GM_Corporate" || user.partnerType === "GM_Wholesale"  ? (
                            <AdminDropDown />
                        ) : undefined}
                        <LanguageSelection />
                    </Stack>
                </AppBar>
                <HistoryProvider>
                    <Stack direction="row" sx={styles.breadCrumbs}><FleetBreadcrumbs /></Stack>
                </HistoryProvider>
            </Box>
        </Box >

    )

}
export default Header;